import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DevelopmentHelpers } from '../../shared/utilities/developHelpers';

@Component({
  selector: 'tinyMCE-image',
  templateUrl: './tiny-mce-image.component.html',
  styleUrls: ['./tiny-mce-image.component.css']
})
export class TinyMCEImageComponent implements OnInit {
  
  @Input() target;
  @Input() files = [];
  @Output() htmlString = new EventEmitter();

  help = new DevelopmentHelpers();
  id = this.help.guid.newGUID();
  hover: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  drop(e:DragEvent){
    e.preventDefault();
    let text = e.dataTransfer.getData('text');
    if(!!text && !!this.target) {
      this.htmlString.emit('<img src="' + text + '" height="100" width="100"/>')
    }
  }

  preExistingFileClick(e){
    console.log(e)
    let t = e.target;
    let h = t.naturalHeight;
    let w = t.naturalWidth;
    this.htmlString.emit('<img src="' + e.target.src + '" height="'+ ((h / w) * 100) +'" width="'+ 100 +'"/>')
  }

  allowDrop(e){
    e.preventDefault()
  }

}